<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <v-card border class="mb-5">
      <v-card-text class="d-flex align-center justify-space-between">
        <div class="d-flex flex-column flex-grow-1">
          <span class="label mb-0">Рівень доступу до документів</span>
          <span class="text-medium-emphasis font-size-12">
            Користувач отримує доступ до документів з усіма обраними грифами
            конфіденційності
          </span>

          <div class="d-flex align-center flex-wrap ga-2 mt-4">
            <v-chip
              v-for="accessLevel in selectedAccessLevels"
              :key="accessLevel.id"
              :closable="!readonly"
              border
              color="blue-darken-3"
              density="comfortable"
              rounded="lg"
              size="small"
              variant="tonal"
              @click:close="removeAccessLevel(accessLevel)">
              <span class="font-weight-bold">{{ accessLevel.name }}</span>
            </v-chip>

            <span
              v-if="!selectedAccessLevels.length"
              class="text-disabled font-size-13">
              Жодного рівня не призначено
            </span>
          </div>
        </div>

        <v-menu v-if="!readonly">
          <template #activator="{ props }">
            <v-btn
              :disabled="!availableAccessLevels.length"
              :loading="$loading.isLoading('userAccessLevelCreate')"
              border
              color="white"
              v-bind="props">
              <div class="d-flex align-center ga-1">
                <v-icon>mdi-plus</v-icon>
                <span>Додати рівень</span>
              </div>
            </v-btn>
          </template>

          <v-card class="access-level-menu" min-width="280px">
            <v-list class="bg-white" density="compact">
              <v-list-item
                v-for="accessLevel in availableAccessLevels"
                :key="accessLevel.id"
                class="access-level-menu__item"
                @click="addAccessLevel(accessLevel)">
                <v-list-item-title class="font-size-13 font-weight-bold">
                  {{ accessLevel.name }}
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-if="!availableAccessLevels.length">
                <v-list-item-title class="text-disabled font-size-13">
                  Усі рівні вже додані
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-card-text>
    </v-card>
    <v-card border class="mb-5">
      <v-card-text>
        <div class="d-flex flex-column">
          <span class="label mb-0">Роль доступу</span>
          <span class="text-medium-emphasis font-size-12">
            Роль визначає набір прав користувача. Користувач має лише одну роль
            одночасно.
          </span>
        </div>
        <div class="w-40 mt-1">
          <b-select
            v-model="user.roleId"
            :items="$directory.get('roles', user?.role)"
            :loading="$loading.isLoading('roles')"
            :readonly="readonly"
            hide-details
            @focus="$directory.fill('roles')"
            @update:model-value="updateUserRole">
          </b-select>
        </div>
      </v-card-text>
    </v-card>

    <div class="d-flex flex-column">
      <div class="d-flex align-center ga-1">
        <span class="font-weight-bold">Права доступу для ролі:</span>
        <v-chip
          border
          color="blue-darken-3"
          density="comfortable"
          rounded="lg"
          size="small"
          variant="tonal">
          <span class="font-weight-bold">{{ user?.role?.name }}</span>
        </v-chip>
      </div>
      <span class="text-medium-emphasis font-size-12">
        Перелік дозволених і заборонених дій. Для зміни прав ролі зверніться до
        адміністратора системи.
      </span>
    </div>

    <div class="d-flex flex-column ga-5">
      <v-card v-for="group in permissionGroups" :key="group.key" border>
        <v-card-text class="pa-0">
          <div
            class="px-4 py-4 font-size-13 font-weight-bold"
            style="background: #fafbfc; border-bottom: 1px solid #f0f0f5">
            {{ group.title }}
          </div>

          <div
            v-for="permission in group.items"
            :key="permission.label"
            class="permission-block">
            <div class="font-size-14">
              {{ permission.label }}
            </div>

            <v-chip
              :color="permission.allowed ? 'green-lighten-5' : 'red-lighten-5'"
              density="comfortable"
              rounded="lg"
              size="small"
              variant="flat">
              <v-icon
                :color="permission.allowed ? 'success' : 'error'"
                class="mr-1"
                size="small">
                {{ permission.allowed ? 'mdi-check-bold' : 'mdi-close' }}
              </v-icon>
              <span
                :class="permission.allowed ? 'text-success' : 'text-error'"
                class="font-weight-bold">
                {{ permission.allowed ? 'Дозволено' : 'Заборонено' }}
              </span>
            </v-chip>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { useUserCardStore } from '@/dialog/components/user-card/store'
import { useUserCardPermissionsStore } from '@/dialog/components/user-card/tabs/permissions/permissions'
import { fillDirectory } from '@/directory/index.ts'

export default {
  name: 'UserCardPermissions',
  setup() {
    fillDirectory(['accessLevelTypes'])

    return {
      ...useUserCardStore(),
      ...useUserCardPermissionsStore(),
    }
  },
}
</script>

<style lang="scss" scoped>
.permission-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #f5f5f8;
}

.access-level-menu {
  border: 1px solid #e4e4ee !important;
  border-radius: 12px !important;
  padding: 6px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.14) !important;
}

.access-level-menu__item {
  border-radius: 8px;

  &:hover {
    background: #f5f6fa !important;
  }
}
</style>
